if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
      } 
      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        
            const productTagInput = this.form.querySelector('[name="tag"]');
            const productTag = productTagInput ? productTagInput.value : '';
            
            const fields = [
              { select: this.form.elements['properties[搬入搬出]'], errorEl: document.getElementById('carry-error') },
              { select: this.form.elements['properties[シェア出店者・店舗名]'], errorEl: document.getElementById('share-error') },
              { select: this.form.elements['properties[シェア出店者・メールアドレス]'], errorEl: document.getElementById('share-error') },
            ];

            let hasError = false;
            fields.forEach(({ select, errorEl }) => {
              if (!select || select.disabled) return;
              const value = select.value || '';
              const invalid = value === '' || value.includes('選択');
              if (invalid) {
                errorEl.style.display = 'block';
                select.classList.add('error');
                hasError = true;
              } else {
                errorEl.style.display = 'none';
                select.classList.remove('error');
              }
            });
            if (hasError) return;
 

        fetch('/cart.js')
          .then(res => res.json())
          // --- cart.js 取得後の then(cart => { ... }) 内の先頭付近を修正 ---
.then(cart => {
  const selectedVariantIdEl = this.form.querySelector('[name="id"]');
  const selectedVariantId = selectedVariantIdEl ? selectedVariantIdEl.value : '';

  // ------------------------------------------------------------
  // ▼ 数量UI（Quantity-{{ section.id }}）が存在しない商品があるため
  //   null 安全に dataset.cartQuantity を取得する
  // ------------------------------------------------------------
  const sectionIdEl = this.form.querySelector('[name="sectionId"]');
  const sectionIdValue = sectionIdEl ? sectionIdEl.value : '';

  // 例: "Quantity-template--xxxx__main" を探す
  const quantityInput = sectionIdValue ? document.getElementById(sectionIdValue) : null;

  // cartQuantity は「なければ 0」
  const cartQuantityValue = quantityInput?.dataset?.cartQuantity
    ? Number(quantityInput.dataset.cartQuantity)
    : 0;

  // 追加しようとしている数量は「なければ 1」
  // ※あなたの実装では window.productQuantity を使っているのでフォールバックを入れる
  const addingQty = window.productQuantity != null ? Number(window.productQuantity) : 1;

  // デバッグログ（原因追跡用）
  console.log('[product-form] sectionIdValue:', sectionIdValue);
  console.log('[product-form] quantityInput:', quantityInput);
  console.log('[product-form] cartQuantityValue:', cartQuantityValue);
  console.log('[product-form] addingQty:', addingQty);

  const productTagInput = this.form.querySelector('[name="tag"]');
  const productTag = productTagInput ? productTagInput.value : '';

  // ------------------------------------------------------------
  // ▼ レンタル上限チェック（dataset が無い/quantity UI が無い商品でも落ちない）
  // ------------------------------------------------------------
  if (productTag.includes('傾斜台')) {
    const totalQuantity = cartQuantityValue + addingQty;
    console.log('[rental] 傾斜台 totalQuantity:', totalQuantity);

    if (totalQuantity > 4) {
      const el = document.getElementById('lental-sloping-error');
      if (el) el.style.display = 'block';
      return;
    } else {
      const el = document.getElementById('lental-sloping-error');
      if (el) el.style.display = 'none';
    }

  } else if (productTag.includes('販売台')) {
    const totalQuantity = cartQuantityValue + addingQty;
    console.log('[rental] 販売台 totalQuantity:', totalQuantity);

    if (totalQuantity > 2) {
      const el = document.getElementById('lental-table-error');
      if (el) el.style.display = 'block';
      return;
    } else {
      const el = document.getElementById('lental-table-error');
      if (el) el.style.display = 'none';
    }
  }

  // ------------------------------------------------------------
  // ▼ イベント商品が既にカートにあるかチェック（既存のまま）
  // ------------------------------------------------------------
  if (productTag.includes('イベント')) {
    const hasEventItem = cart.items.some(item => {
      return item.properties && item.properties._event_product === "1";
    });

    const errorBox = document.getElementById('cart-error');
    if (hasEventItem) {
      if (errorBox) errorBox.style.display = "block";
      return;
    } else {
      if (errorBox) errorBox.style.display = "none";
    }
  }

  // --- ここから下は元コードの submit 処理に続く ---
  this.submitButton.setAttribute('aria-disabled', true);
  this.submitButton.classList.add('loading');
  this.querySelector('.loading__spinner').classList.remove('hidden');

  const config = fetchConfig('javascript');
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  delete config.headers['Content-Type'];

  const formData = new FormData(this.form);
  console.log('[product-form] formData:', [...formData.entries()]);

  if (this.cart) {
    formData.append(
      'sections',
      this.cart.getSectionsToRender().map(section => section.id)
    );
    formData.append('sections_url', window.location.pathname);
    this.cart.setActiveElement(document.activeElement);
  }
  config.body = formData;

  fetch(`${routes.cart_add_url}`, config)
    .then(response => response.json())
    .then(response => {
      if (response.status) {
        this.handleErrorMessage(response.description);
        return;
      }
      if (!this.cart) {
        window.location = window.routes.cart_url;
        return;
      }
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'product-form',
        productVariantId: formData.get('id'),
        cartData: response,
      }).then(() => this.cart.renderContents(response));
    })
    .catch(e => console.error(e))
    .finally(() => {
      this.submitButton.classList.remove('loading');
      this.querySelector('.loading__spinner').classList.add('hidden');
      if (!this.error) this.submitButton.removeAttribute('aria-disabled');
    });
          })
          .catch(e => console.error(e));
      }



      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
